import { format, isValid } from "date-fns";
import { ptBR } from "date-fns/locale";

/**
 * Formata uma data no formato local
 * @param date - Data no formato 'YYYY-MM-DD'
 * @returns Data formatada ou 'Data inválida' se for inválida
 */
export const formatDateLocalized = (date: string): string => {
  const [year, month, day] = date.split("-").map(Number);
  const parsedDate = new Date(year, month - 1, day);

  return isValid(parsedDate)
    ? format(parsedDate, "dd MMM", { locale: ptBR })
    : "Data inválida";
};
